export enum CriteriaTypeOptions {
    Custom = 'Custom',
    Standard = 'Standard'
}